import { BeneficiaryFilterNumberType } from '@repo/shared/dtos/beneficiary'
import { NumberSchemaItem } from '@repo/shared/dtos/structured-data'

import { FilterWrapper } from './FilterWrapper'
import NumberFilterForm from './NumberFilterForm'
import { FilterProps } from './types'

export default function NumberFilter(
  props: FilterProps<BeneficiaryFilterNumberType, NumberSchemaItem>,
) {
  if (props.readonly) return <FilterWrapper {...props} />
  return (
    <FilterWrapper
      {...props}
      renderForm={(onCancel) => (
        <NumberFilterForm filter={props.filter} onChange={props.onChange} onCancel={onCancel} />
      )}
    />
  )
}
